<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <label>Nombre par page</label>
            <b-form-group class="mb-0">
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col md="3" sm="8" class="my-1">
            <label>Trier</label>
            <b-form-group label-for="sortBySelect" class="mb-0">
              <b-input-group size="sm">
                <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" class="w-75">
                  <template #first>
                    <option value="">-- Vide --</option>
                  </template>
                </b-form-select>
                <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="3" class="my-1">
            <label>Filtrer</label>
            <b-form-group class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..." />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col class="my-1">
            <label class="d-inline-block">Année</label>
            <v-select v-model="currentYear" label="year" :options="years" />
          </b-col>

          <!-- <b-col cols="12">
            <div class="d-flex flex-wrap">
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="propose">Proposition</b-form-checkbox>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="valide1">Validé par manager N°1</b-form-checkbox>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="valide2">Validé par manager N°2</b-form-checkbox>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="rejete">Rejeté</b-form-checkbox>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="valideCollab">Validé collaborateur</b-form-checkbox>
              </b-col>
              <b-col md="3" class="my-1">
                <b-form-checkbox v-model="transmis2">Transmis au manager N°2</b-form-checkbox>
              </b-col>
            </div>
          </b-col> -->


          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="relances"
              :fields="tableColumns"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item.user) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.user.fullName }}
                  </span>
                  <small class="text-muted">{{ data.item.user.mail }}</small>
                </b-media>
              </template>

              <template #cell(module)="data">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ data.item.objective ? "Objectif" : "Evaluation" }}
                </span>
              </template>

              <template #cell(typeRelance)="data">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ data.item.objective ? data.item.typeRelance : data.item.evaluationTypeRelance }}
                </span>
                <small class="text-muted">{{ data.item.objective ? "Objectif " + data.item.year : "Evaluation " + data.item.year }}</small>
              </template>

              <!-- Services
              <template #cell(services)="data">
                {{ data.item.user.services.name }}
              </template> -->

              <!-- Slot personnalisé pour la date -->
              <template #cell(relanceDate)="data">
                {{ formatDate(data.item.relanceDate) }}
              </template>

            </b-table>
          </b-col>
        </b-row>
      </b-card-body>

      <b-col cols="12">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-1"
        />
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BRow, BCol, BFormGroup, BFormSelect, BPagination,
  BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { getAllHistoryRelances } from '@/services/HistoryRelanceService'
import { allYears } from '@/services/YearsService'

export default {
  components: {
    BTable, BAvatar, BRow, BCol, BFormGroup, BFormSelect, BPagination,
    BInputGroup, BFormInput, BInputGroupAppend, BButton,
    vSelect
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      relances: [],
      termine: true,
      rdv: true,
      valid: true,
      accept: true,
      currentYear: { year: new Date().getFullYear() },
      years: [],
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        // { key: 'services', label: 'Service', sortable: true },
        { key: 'typeRelance', label: 'Type de relance', sortable: true },
        { key: 'relanceNumber', label: 'Nombre', sortable: true },
        { key: 'relanceDate', label: 'Date de relance', sortable: true },
      ]
    },
    sortOptions() {
      return this.tableColumns.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },
  },
  methods: {
    getUserInitials(user) {
      const firstInitial = user.firstName?.charAt(0).toUpperCase() || ''
      const lastInitial = user.lastName?.charAt(0).toUpperCase() || ''
      return `${lastInitial}${firstInitial}`
    },
    async fetchRelances() {
      try {
        const response = await getAllHistoryRelances()
        if (response) {
          this.relances = response
          this.totalRows = this.relances.length
        }
      } catch (error) {
        console.error('Erreur chargement relances :', error)
      }
    },
    async getAllYears() {
      try {
        const response = await allYears()
        this.years = response || []
      } catch (error) {
        console.error('Erreur chargement années :', error)
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }

  },
  watch: {
    currentYear: 'fetchRelances',
    termine: 'fetchRelances',
    rdv: 'fetchRelances',
    valid: 'fetchRelances',
    accept: 'fetchRelances',
    currentPage: 'fetchRelances',
    perPage: 'fetchRelances'
  },
  mounted() {
    this.getAllYears()
    this.fetchRelances()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
